import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateProjectKeyInputWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  .form-container {
    padding: 0px 0px 16px 16px;
    ${responsive.MOBILE`
    padding: 0px 0px 16px 8px;
    `}
  }
  .MuiGrid2-root {
    padding-right: 16px;
    ${responsive.MOBILE`
      padding-right: 4px;  
    `}
  }

  .update-input-general {
    .MuiAccordionSummary-root,
    .MuiAccordion-heading {
      display: none;
    }
    .form-container {
      padding: 0 0 24px 16px;
      ${responsive.MOBILE`
        padding: 0 16px 16px 16px;  
      `}
    }
  }
`;
